import { getFileNameFromHeader } from '../util/getFileNameFromHeader';
import PropTypes from 'prop-types';

export const trackingEventType = {
	Preview: 6,
	DownLoad: 7,
	Print: 8,
	SendToPrintVendor: 9,
	QuickSheetPreview: 14,
	QuickSheetPrint: 15,
	QuickSheetSendToPrintVendor: 16,
	QuickSheetDownload: 11
};

export const documentGenerationType = {
	Generate: 0,
	Preview: 1,
};

export const documentType = {
	All: 0,
	Dynamic: 1,
	Static: 2,
};

placePrintOrder.propTypes = {
	userId: PropTypes.string.isRequired,
	numberOfCopies: PropTypes.number.isRequired,
	id: PropTypes.number.isRequired, // Represents either sellSheetId or quickSheetId
	addressId: PropTypes.string.isRequired,
	isQuickSheet: PropTypes.bool,
};

export async function documentGenerate(props) {
	const url = `${process.env.REACT_APP_API_URL}Document/Generate`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props),
	};
	const response = await fetch(url, parameters);
	if (response.status === 200) {
		let fileName = getFileNameFromHeader(response);
		let sellSheetId = response.headers.get('sellsheetId');
		let purchaseOrderNumber = response.headers.get('purchaseOrderNumber');

		var blob = await response.blob();
		return {
			blob,
			fileName,
			sellSheetId,
			purchaseOrderNumber
		};
	} else {
		throw response.statusText;
	}
}

export async function documentGenerateContainer(props) {
	const url = `${process.env.REACT_APP_API_URL}Document/Container/Generate`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props),
	};
	const response = await fetch(url, parameters);
	if (response.status === 200) {
		let fileName = getFileNameFromHeader(response);
		let sellSheetId = response.headers.get('sellsheetId');
		let purchaseOrderNumber = response.headers.get('purchaseOrderNumber');	

		const blob = await response.blob();
		return {
			blob,
			fileName,
			sellSheetId,
			purchaseOrderNumber
		};
	} else {
		throw response.statusText;
	}
}

export async function documentGeneratePlanless(props) {
	const { selectedPlans, ...planlessProps } = props;
	const url = `${process.env.REACT_APP_API_URL}Document/Planless/Generate`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(planlessProps),
	};
	const response = await fetch(url, parameters);
	if (response.status === 200) {
		let fileName = getFileNameFromHeader(response);
		let sellSheetId = response.headers.get('sellsheetId');
		let purchaseOrderNumber = response.headers.get('purchaseOrderNumber');

		const blob = await response.blob();
		return {
			blob,
			fileName,
			sellSheetId,
			purchaseOrderNumber
		};
	} else {
		throw response.statusText;
	}
}

export async function documentGenerateContainerPlanless(props) {
	const { selectedPlans, ...planlessProps } = props;
	const url = `${process.env.REACT_APP_API_URL}Document/Container/Planless/Generate`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(planlessProps),
	};
	const response = await fetch(url, parameters);
	if (response.status === 200) {
		let fileName = getFileNameFromHeader(response);
		let sellSheetId = response.headers.get('sellsheetId');
		let purchaseOrderNumber = response.headers.get('purchaseOrderNumber');

		const blob = await response.blob();
		return {
			blob,
			fileName,
			sellSheetId,
			purchaseOrderNumber
		};
	} else {
		throw response.statusText;
	}
}

export async function batchPrintDocumentGenerate(props) {
	const url = `${process.env.REACT_APP_API_URL}BatchPrint/Document/Generate`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props),
	};
	const response = await fetch(url, parameters);
	if (response.status === 200) {
		let fileName = getFileNameFromHeader(response);
		let sellSheetId = response.headers.get('sellsheetId');
		let purchaseOrderNumber = response.headers.get('purchaseOrderNumber');

		let blob = await response.blob();
		return {
			blob,
			fileName,
			sellSheetId,
			purchaseOrderNumber
		};
	} else {
		throw response.statusText;
	}
}

export async function trackDocumentRequest(eventType, props, sellSheetId, quickSheetId) {
	const url = `${process.env.REACT_APP_API_URL}TrackActivity`;

	const data = {
		eventType: eventType,
		value: JSON.stringify(props),
		sellSheetId: sellSheetId,
		quickSheetId: quickSheetId,
	};

	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	};

	const response = await fetch(url, parameters);
	if (!response.ok) {
		throw response.statusText;
	}
}

export async function downloadTemplate(id) {
	const url = `${process.env.REACT_APP_API_URL}Template/Download/${id}`;
	const parameters = {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	};
	const response = await fetch(url, parameters);
	if (response.ok) {
		let fileName = getFileNameFromHeader(response);
		var blob = await response.blob();
		return {
			blob,
			fileName,
		};
	} else {
		throw response.statusText;
	}
}

export async function getStaticTemplate(id) {
	const url = `${process.env.REACT_APP_API_URL}Template/${id}`;
	const parameters = {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	};
	const response = await fetch(url, parameters);
	if (response.ok) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function placePrintOrder(userId, numberOfCopies, id, addressId, isQuickSheet = false) {
	const data = {
		userId: userId,
		numberOfCopies: numberOfCopies,
		mailingAddressId: addressId,
	};

	if (isQuickSheet) {
		data.quickSheetId = id;
	} else {
		data.sellSheetId = id;
	}

	const url = `${process.env.REACT_APP_API_URL}Document/${isQuickSheet ? 'SendQuickSheetToQueue' : 'SendToQueue'}`;
	const parameters = {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	};

	const response = await fetch(url, parameters);

	if (response.ok) {
		return response;
	} else {
		throw response.statusText;
	}
}
